import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const NAV = [
  { group: 'Overview', items: [
    { to:'/',         icon:'⬡', label:'Dashboard',
      roles:['super_admin','platform_admin','content_manager','editor','contributor','trainer','partner','finance_admin'] },
  ]},

  { group: 'Content', items: [
    { to:'/content',     icon:'◈', label:'Pages & Content',  roles:['super_admin','platform_admin','content_manager'] },
    { to:'/articles',    icon:'◎', label:'Articles & Media', roles:['super_admin','platform_admin','content_manager','editor','contributor'] },
    { to:'/media',       icon:'◈', label:'Media Library',    roles:['super_admin','platform_admin','content_manager','editor'] },
    { to:'/media-slots', icon:'▶', label:'Media Slots',      roles:['super_admin','platform_admin'] },
  ]},

  { group: 'Marketplace', items: [
    { to:'/services',  icon:'◉', label:'Services',   roles:['super_admin','platform_admin','content_manager'] },
    { to:'/products',  icon:'◈', label:'Products',   roles:['super_admin','platform_admin'] },
    { to:'/ecosystem', icon:'⬡', label:'Ecosystem',  roles:['super_admin','platform_admin','content_manager'] },
  ]},

  { group: 'Academy', items: [
    { to:'/programs',     icon:'◐',  label:'Programs & Training',    roles:['super_admin','platform_admin','content_manager','trainer'] },
    { to:'/enrollments',  icon:'◎',  label:'Enrollments',            roles:['super_admin','platform_admin','content_manager','trainer'] },
    { to:'/submissions',  icon:'📝', label:'Submissions & Grading',  roles:['super_admin','platform_admin','trainer'] },
    { to:'/internships',  icon:'◈',  label:'Internships',            roles:['super_admin','platform_admin','content_manager'] },
    { to:'/trainers',     icon:'◉',  label:'Trainers',               roles:['super_admin','platform_admin'] },
    { to:'/partners',     icon:'⬡',  label:'Partner Institutions',   roles:['super_admin','platform_admin'] },
  ]},

  { group: 'Certificates', items: [
    { to:'/cert-templates', icon:'◈', label:'Templates',    roles:['super_admin','platform_admin'] },
    { to:'/certificates',   icon:'◎', label:'Issued Certs', roles:['super_admin','platform_admin','content_manager','trainer'] },
  ]},

  { group: 'Finance', items: [
    { to:'/orders',   icon:'🛒', label:'Orders',            roles:['super_admin','platform_admin','finance_admin'] },
    { to:'/payments', icon:'◈', label:'Payments & Revenue', roles:['super_admin','platform_admin','finance_admin'] },
  ]},

  { group: 'Engagement', items: [
    { to:'/inbox',    icon:'◻', label:'Inbox & Applications', roles:['super_admin','platform_admin','content_manager','finance_admin'] },
    { to:'/social',   icon:'◎', label:'Social Media',         roles:['super_admin','platform_admin','content_manager'] },
    { to:'/sms',      icon:'📱', label:'SMS Center',           roles:['super_admin','platform_admin'] },
  ]},

  { group: 'System', items: [
    { to:'/users',    icon:'◯', label:'Users & Roles', roles:['super_admin','platform_admin'] },
    { to:'/activity', icon:'▷', label:'Activity Log',  roles:['super_admin'] },
  ]},
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const role = user?.role || '';

  const filteredNav = NAV
    .map(g => ({ ...g, items: g.items.filter(i => i.roles.includes(role)) }))
    .filter(g => g.items.length > 0);

  return (
    <aside style={{
      position:'fixed', top:0, left:0, bottom:0, width:'var(--sidebar-w)',
      background:'var(--bg-surface)', borderRight:'1px solid var(--border)',
      display:'flex', flexDirection:'column', zIndex:100,
    }}>

      {/* Logo */}
      <div style={{ padding:'0 20px', height:'var(--header-h)', display:'flex', alignItems:'center', borderBottom:'1px solid var(--border)', gap:10, flexShrink:0 }}>
        <img src="/logos/logo-dark.png" alt="MilleHills"
          style={{ height:32, width:'auto', objectFit:'contain', flexShrink:0 }}
          onError={e=>{ e.target.style.display='none'; e.target.nextSibling.style.display='flex'; }}/>
        <div style={{ display:'none', width:28, height:28, background:'var(--accent)', borderRadius:6, alignItems:'center', justifyContent:'center', fontSize:14, fontWeight:800, color:'#0d0f12', fontFamily:'var(--font-display)' }}>M</div>
        <div>
          <div style={{ fontFamily:'var(--font-display)', fontWeight:700, fontSize:14, lineHeight:1.2 }}>MilleHills</div>
          <div style={{ fontSize:10, color:'var(--text-muted)', letterSpacing:'0.05em' }}>ADMIN CONSOLE</div>
        </div>
      </div>

      {/* Nav */}
      <nav style={{ flex:1, overflowY:'auto', padding:'16px 12px' }}>
        {filteredNav.map(group => (
          <div key={group.group} style={{ marginBottom:24 }}>
            <div style={{ fontSize:10, fontWeight:600, letterSpacing:'0.1em', textTransform:'uppercase', color:'var(--text-muted)', padding:'0 8px', marginBottom:6 }}>
              {group.group}
            </div>
            {group.items.map(item => {
              const isActive = item.to === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(item.to);
              return (
                <NavLink key={item.to} to={item.to}
                  style={{
                    display:'flex', alignItems:'center', gap:10,
                    padding:'8px 10px', borderRadius:'var(--radius-sm)',
                    fontSize:13, fontWeight:isActive?500:400,
                    color:isActive?'var(--accent)':'var(--text-secondary)',
                    background:isActive?'var(--accent-muted)':'transparent',
                    marginBottom:1, transition:'all 0.15s',
                    textDecoration:'none', position:'relative',
                  }}
                  onMouseEnter={e=>{ if(!isActive){ e.currentTarget.style.background='var(--bg-hover)'; e.currentTarget.style.color='var(--text-primary)'; }}}
                  onMouseLeave={e=>{ if(!isActive){ e.currentTarget.style.background='transparent'; e.currentTarget.style.color='var(--text-secondary)'; }}}
                >
                  {isActive && (
                    <div style={{ position:'absolute', left:0, top:'50%', transform:'translateY(-50%)', width:2, height:'60%', background:'var(--accent)', borderRadius:'0 2px 2px 0' }}/>
                  )}
                  <span style={{ fontSize:15, lineHeight:1 }}>{item.icon}</span>
                  {item.label}
                </NavLink>
              );
            })}
          </div>
        ))}
      </nav>

      {/* User footer */}
      <div style={{ padding:'12px 16px', borderTop:'1px solid var(--border)', display:'flex', alignItems:'center', gap:10 }}>
        <div style={{ width:30, height:30, borderRadius:'50%', background:'var(--accent-muted)', border:'1px solid var(--accent)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:700, color:'var(--accent)', fontFamily:'var(--font-display)', flexShrink:0 }}>
          {user?.name?.[0]?.toUpperCase()||'A'}
        </div>
        <div style={{ flex:1, minWidth:0 }}>
          <div style={{ fontSize:12, fontWeight:500, color:'var(--text-primary)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{user?.name||'Admin'}</div>
          <div style={{ fontSize:10, color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.05em' }}>{user?.role?.replace(/_/g,' ')||'role'}</div>
        </div>
        <button onClick={logout} title="Sign out"
          style={{ color:'var(--text-muted)', fontSize:14, padding:4, borderRadius:4, transition:'color 0.15s', background:'none', border:'none', cursor:'pointer' }}
          onMouseEnter={e=>e.currentTarget.style.color='var(--red)'}
          onMouseLeave={e=>e.currentTarget.style.color='var(--text-muted)'}
        >⏻</button>
      </div>
    </aside>
  );
}
